import { project2BaseUrl } from './remoteClient'

export async function requestCourses(token) {
    return await project2BaseUrl.get('/courses/getCourses', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}
export async function createCourse(token, course) {
    return await project2BaseUrl.post('/courses/createCourse', course, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}
export async function updateCourse(token, course) {
    return await project2BaseUrl.post('/courses/updateCourse', course, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

}
export async function deleteCourse(token, courseId) {

    return await project2BaseUrl.post('/courses/deleteCourse?courseId=' + courseId, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

}
export async function requestCourseTypes(token) {
    return await project2BaseUrl.get('/courses/getCourseTypes', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}
export async function getCourseSkills(token, courseId) {
    return await project2BaseUrl.get('/courses/getCourseSkills?courseId=' + courseId, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export async function updateCourseSkills(token, courseId, skills) {
    return await project2BaseUrl.post('/courses/updateCourseSkills?courseId=' + courseId, skills, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

